// extracted by mini-css-extract-plugin
export var cardHeader = "_u6-0";
export var reorderHandle = "_u6-3";
export var titleArea = "_u6-1";
export var titleAreaWithHandle = "_u6-2";